import http from '@services/http'

export default {
  getReportDetail(data: object): Promise<any> {
    return http.get('user-api/na/task/queryPushTaskDetail', data || {})
  }
}
